import styled, { keyframes } from 'styled-components';
import { RADIUS } from '../radius/radius';
import {
  COLOR_OVERLAY_HOVER,
  COLOR_TEXT_PRIMARY,
  COLOR_TEXT_SECONDARY,
} from '../colors/colors';

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-align: center;
`;

export const ModalHeaderImage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Title = styled.h2`
  font-size: 18px;
  font-weight: 700;
  color: ${COLOR_TEXT_PRIMARY};
  margin: 0;
`;

export const ModalDescription = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: ${COLOR_TEXT_SECONDARY};
  margin: 0;
  line-height: 1.4;
`;

export const ModalActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  margin-top: 8px;
`;

export const OutlinedButton = styled.button`
  width: 100%;
  padding: 14px 24px;
  border: 1px solid ${COLOR_TEXT_PRIMARY};
  background: transparent;
  color: ${COLOR_TEXT_PRIMARY};
  border-radius: ${RADIUS.SM};
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: background 0.15s ease, opacity 0.15s ease;

  &:hover:not(:disabled) {
    background: ${COLOR_OVERLAY_HOVER};
  }

  &:active:not(:disabled) {
    transform: scale(0.99);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const LoadingSpinner = styled.span`
  display: inline-block;
  width: ${({ size }) => size || '16px'};
  height: ${({ size }) => size || '16px'};
  border-radius: ${RADIUS.CIRCLE};
  border: 2px solid currentColor;
  border-top-color: transparent;
  animation: ${spin} 0.8s linear infinite;
`;
